export default __webpack_public_path__ + "static/media/totalAplicacionEfectivo.e45737f7.svg";